import { FaChild } from "react-icons/fa";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import Rating from "./Rating";
import { useGetDiscountQuery } from "../slices/discountApiSlice";

const Product = ({ product }) => {
  const { data: discount } = useGetDiscountQuery();

  const discountActive =
    discount?.isActive &&
    discount?.endTime &&
    new Date() <= new Date(discount.endTime) &&
    discount.percentage > 0;

  const discountedPrice = discountActive
    ? Math.round(product.price * (1 - discount.percentage / 100))
    : null;
  return (
    <Card className="my-3 p-3 rounded card-hover h-100">
      <Link to={`/product/${product._id}`}>
        <div style={{ height: "180px", overflow: "hidden" }}>
          <Card.Img
            src={product.image}
            variant="top"
            loading="lazy"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </div>
      </Link>
      <Card.Body className="d-flex flex-column">
        <Link to={`/product/${product._id}`} style={{ textDecoration: "none" }}>
          <Card.Title as="div" className="product-title">
            <strong
              style={{
                textAlign: "right",
                color: "#333333",
                display: "block",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                direction: "rtl",
              }}
            >
              {product.name}
            </strong>
          </Card.Title>
        </Link>

        <Card.Text
          as="div"
          style={{ textAlign: "right", marginTop: "-10px", color: "#333333" }}
        >
          <Rating
            value={product.rating}
            text={
              <span dir="rtl">
                <span dir="ltr">{product.numReviews}</span> תגובות
              </span>
            }
          />
        </Card.Text>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            marginTop: "auto",
            paddingTop: "1rem",
          }}
        >
          <Card.Text as="h3" style={{ color: "#333333", margin: 0 }}>
            {discountActive ? (
              <span>
                <span
                  style={{
                    textDecoration: "line-through",
                    color: "#999",
                    fontSize: "0.6em",
                    marginRight: "8px",
                  }}
                >
                  ₪{product.price}
                </span>
                <span style={{ color: "#6B46C1", fontWeight: "700" }}>
                  ₪{discountedPrice}
                </span>
              </span>
            ) : (
              <span>₪{product.price}</span>
            )}
          </Card.Text>
          <span
            style={{
              color: "#333333",
              display: "flex",
              alignItems: "center",
              gap: "0.3rem",
              paddingBottom: "0.3rem",
            }}
          >
            <FaChild />
            <span style={{ fontSize: "0.9rem" }}>+{product.forAge}</span>
          </span>
        </div>
      </Card.Body>
    </Card>
  );
};
export default Product;
